/**
 * aramBridgeCollision — Murder Bridge rail + void wallBoxes (P3-02).
 * Domain-owned collision aligned with aramBridgeMeshes + map bounds pad.
 *
 * Contrato:
 *   getAramRailWallBoxes / getAramVoidWallBoxes / getAramBridgeWallBoxes
 */

import {
  ARAM_BRIDGE_WIDTH,
  ARAM_HALF_LENGTH
} from './aramScale.js';

/** Matches presentation ARAM_LANE_CONFIG.railThickness. */
export const ARAM_RAIL_THICKNESS = ARAM_BRIDGE_WIDTH * 0.04;

/** Pad beyond deck — must match MAP_CONFIGS.aram bounds pad. */
export const ARAM_BOUND_PAD = 6;

function railBox(centerX) {
  const halfT = ARAM_RAIL_THICKNESS / 2;
  return {
    minX: centerX - halfT,
    maxX: centerX + halfT,
    minZ: -ARAM_HALF_LENGTH,
    maxZ: ARAM_HALF_LENGTH
  };
}

export function getAramRailWallBoxes() {
  const half = ARAM_BRIDGE_WIDTH / 2 + ARAM_RAIL_THICKNESS / 2;
  return [railBox(-half), railBox(half)];
}

/**
 * Four void strips covering bound pad outside the walkable deck.
 * Blocks walking off the Murder Bridge into the void.
 */
export function getAramVoidWallBoxes() {
  const halfW = ARAM_BRIDGE_WIDTH / 2;
  const halfL = ARAM_HALF_LENGTH;
  const pad = ARAM_BOUND_PAD;
  return [
    {
      minX: -(halfW + pad),
      maxX: -halfW,
      minZ: -(halfL + pad),
      maxZ: halfL + pad
    },
    {
      minX: halfW,
      maxX: halfW + pad,
      minZ: -(halfL + pad),
      maxZ: halfL + pad
    },
    {
      minX: -halfW,
      maxX: halfW,
      minZ: halfL,
      maxZ: halfL + pad
    },
    {
      minX: -halfW,
      maxX: halfW,
      minZ: -(halfL + pad),
      maxZ: -halfL
    }
  ];
}

export function getAramBridgeWallBoxes() {
  return [...getAramRailWallBoxes(), ...getAramVoidWallBoxes()];
}
